// SideScreenLoader.js
// This loads an overlay over the current screen and closes back to reveal the parent screen.

import React, { useCallback, useEffect, useRef, useState } from "react";
import { View, Text, Pressable, Animated, useWindowDimensions } from "react-native";
import { Feather } from "@react-native-vector-icons/feather";  // https://feathericons.com/?query=
import * as SideScreens from "components/Views/SideScreens/Index";

var openSideScreen;
const slide_in_time = 500;
const slide_out_time = 300;

const SideScreen = () => {
  const [sideScreensState, sideScreensSetState] = useState([]);
  const _sideScreens = useRef([]);

  useEffect(() => {
    _sideScreens.current = [...sideScreensState];  // ⬅ Shallow copy
    if (typeof(watcher)==="function") {
      watcher(_sideScreens.current.length);
    }
  }, [sideScreensState]);

  openSideScreen = useCallback((_key, _dataObj)=>{
    const _cache_l1_client_id = Number(_sideScreens.current[0]?.data?.client_id);  // ⬅⬅⬅ Somehow this is getting reset to the NEW client_id before checks happen below.. Cache it here to preserve it for comparisons!
    const _cache_l1_openState = !!_sideScreens.current[_sideScreens.current.length]?.openState;  // ⬅⬅⬅ Somehow this is getting reset to the NEW client_id before checks happen below.. Cache it here to preserve it for comparisons!
    const sideView = SideScreens[_key];
    if (!sideView) {
      console.error(`Sidescreen '${_key}' not found.`);
      return;
    }
    sideView.data = (_dataObj||{});
    sideView.openState = true;
    // Stacked layers must be for the same client. Else, clear all and add new layer fresh.
    // Data attribute '_dataObj.client_id' must always exist in all layer types data for this validation.
    // Validate the first layer 'client_id':
    if (!!_sideScreens.current.length && _cache_l1_client_id!==Number(sideView.data.client_id)) {
      sideScreensSetState([sideView]);
      // console.log(`ACTION: Sidescreens reset to one layer '${_key}' with client_id:'${sideView.data.client_id}'.`);
      return;
    }
    // Check if the target layer already exists, if so, skip it or close layers on top of it.
    const exists_index = _sideScreens.current.findIndex(o=>(o.key===_key));
    if (exists_index > -1) {
      if ((exists_index+1)!==_sideScreens.current.length) {
                // sideScreensSetState((arr)=>{
                //   const _return = [...arr];
                //   _return.length = (exists_index+1);  // Trim off any laters above the target layer.
                //   return _return;
                // });
        sideScreensSetState((arr)=>{
          const _return = [...arr];
          const _length = _sideScreens.current.length;
          for (let i=(_length-1); i>exists_index; i--) {
            _return[i].openState = false;  // trigger the slide-out effect.
          }
          return _return;
        });
        window.setTimeout(()=>{
          sideScreensSetState((arr)=>{
            const _return = [...arr];
            _return.length = (exists_index+1);  // Trim off any laters above the target layer.
            return _return;
          });
        },slide_out_time);
        // console.log(`ACTION: Sidescreens on top of '${_key}' have been closed to reveal the lower sidescreen.`);
        return;
      }
      if (_cache_l1_client_id===_sideScreens.current[exists_index].data.client_id) {
        // console.log(`ACTION: Sidescreen '${_key}' is already open. No change.`, _cache_l1_openState);
                // if (!_cache_l1_openState) {
                //   sideScreensSetState((arr)=>{
                //     const _return = [...arr];
                //     // console.log("RE-SHOWING SIDESCREEN: _return[_return.length-1] =", _return[exists_index]);
                //     _return[_return.length-1].openState = true;  // trigger the slide-IN effect.
                //     return _return;
                //   });
                // }
        return;
      }
      // No change - continue below to add layer...
    }
    // It doesn't exist yet, add it:
    // console.log("ADDING: sideView =", sideView);
    sideScreensSetState((arr)=>{
      const _return = [...arr, sideView];
      // console.log(`ACTION: Sidescreen '${_key}' is set as layer '${_return.length}'.`);
      return _return;
    });
  },[]);

  const closeSideScreen = ()=>{
            // sideScreensSetState((arr)=>{
            //   if (!!arr && Array.isArray(arr) && !!arr.length) {
            //     const _return = [...arr].slice(0, -1);  // ⬅ Returns array minus top layer.
            //     return _return
            //   }
            //   return [];  // ⬅ Returns no layers
            // });
    sideScreensSetState((arr)=>{
      const _return = [...arr];
      _return[_return.length-1].openState = false;  // trigger the slide-out effect.
      return _return;
    });
    window.setTimeout(()=>{
      sideScreensSetState((arr)=>{
        if (!!arr && Array.isArray(arr) && !!arr.length) {
          const _return = [...arr].slice(0, -1);  // ⬅ Returns array minus top layer.
          return _return
        }
        return [];  // ⬅ Returns no layers
      });
    // },500);
    },slide_out_time);
  };

  const clearAllSideScreens = ()=>{
            // sideScreensSetState([]);
            // const _length = _sideScreens.current.length;
            // for (let i=_length-1; i>-1; i--) {
            //   console.log("(100*(_length-i)) =", (100*(_length-i)));
            //     closeSideScreen();
            // }
    sideScreensSetState((arr)=>{
      const _return = [...arr];
      const _length = _sideScreens.current.length;
      for (let i=_length-1; i>-1; i--) {
        _return[i].openState = false;  // trigger the slide-out effect.
      }
      return _return;
    });
    window.setTimeout(()=>{
      sideScreensSetState([]);
    // },500);
    },slide_out_time);
  };

  useEffect(() => {
    if (typeof(opener)==="function") {
      opener(openSideScreen);
    }
    return ()=>{
      if (typeof(opener)==="function") {
        opener(()=>{console.log("function 'openSidescreen' is not initialized!");});
      }
      sideScreensSetState([]);  // Close all layers when un-loading this component.
    };
  }, []);  // ⬅ Trigger only once on initial page load.

  return (
    <>
      {!!sideScreensState && !!sideScreensState.length && sideScreensState.map((SideScreenView,index)=>{
        return (
          <SideScreenInstance key={SideScreenView.key} id={SideScreenView.key} SideScreenView={SideScreenView} index={index} screensStates={sideScreensState} openSideScreen={openSideScreen} closeSideScreen={closeSideScreen} clearAllSideScreens={clearAllSideScreens} />
        );
      })}
    </>
  );
};

export default SideScreen;
export { openSideScreen };


// Helpers

const SideScreenInstance = ({SideScreenView, index, screensStates, openSideScreen, closeSideScreen, clearAllSideScreens})=>{
  // const { height: fullScreenHeight, width: fullScreenWidth } = Dimensions.get("window");
  const { height: fullScreenHeight, width: fullScreenWidth } = useWindowDimensions();
  const _styles = SharedStyles(fullScreenHeight,fullScreenWidth);
  let _view_key = [];
  for (const [key, value] of Object.entries(SideScreenView.data)) {
    _view_key.push(`${key}-${value}`);
  }
  // https://reactnative.dev/docs/animated
  // https://archive.reactnative.dev/docs/0.48/animations
  const [slideAnim] = useState(new Animated.Value(-fullScreenWidth));
  useEffect(() => {
      Animated.timing(slideAnim, {
        toValue: (!!SideScreenView.openState ? 0 : -fullScreenWidth),
        // toValue: 0,
        // duration: 500,
        duration: (!!SideScreenView.openState ? slide_in_time : slide_out_time),
        // useNativeDriver: true, // Supported for transform: translateX
        useNativeDriver: false, // Supported for transform: translateX
      }).start();
  }, [SideScreenView.openState]);
  return (
    <Animated.View key={"sidescreen__"+_view_key.join("_")} id={"sidescreen__"+_view_key.join("_")} style={{..._styles.sideviewContainer,zIndex:index+10,right:slideAnim}}>
      {/* <View key={"sidescreen__"+_view_key.join("_")} id={"sidescreen__"+_view_key.join("_")} style={{..._styles.sideviewContainer,zIndex:index+10}}> */}
        <View style={_styles.backToParentRow}>
          <Pressable style={{}} onPress={closeSideScreen}>
            <Text style={{..._styles.backToParentText,paddingVertical:6}}><Feather name="arrow-left" size={18} style={{marginBottom:-1,display:"inline-block",verticalAlign:"bottom"}} /> Back to {index===0?"Schedule":screensStates[index-1].title}</Text>
          </Pressable>
          <Pressable style={{width:30,flexDirection:"row",justifyContent:"flex-end"}} onPress={clearAllSideScreens}>
            <Text style={{..._styles.backToParentText,paddingTop:3}}><Feather name="x" size={22} style={{marginBottom:-1,display:"inline-block",verticalAlign:"bottom"}} /></Text>
          </Pressable>
        </View>
        <View id="sidescreen_container" style={_styles.sideScreenContainer}>
          <SideScreenView.view id="sidescreen_view" {...SideScreenView.data} />
        </View>
      {/* </View> */}
    </Animated.View>
  );
};

const SharedStyles = (fullScreenHeight,fullScreenWidth)=>{
  const _theme = window.main.theme;
  const sharedStyles = {
    sideviewContainer: {
      alignItems: "flex-start",
      backgroundColor: _theme.colors.mode.containerBackgroundColor3,
      borderTopLeftRadius: 14,
      boxShadow: "0px 0px 10px 10px #00000080",  // boxShadow: "-2px 3px 7px -2px #00000080",
      display: "flex",
      flexDirection: "column",
      fontSize: 0,
      height: (fullScreenHeight-60),  // ⬅ Minus height of 'Header'.
      justifyContent: "stretch",
      lineHeight: 0,
      overflow: "auto",
      position: "absolute",
      right: 0,  // ⬅ Used if animating slide-in from right!
      // left: 0,
      top: 60,
      width: "calc(-2px + 100%)",  // width: "100%",
    },
    backToParentRow: {
      backgroundColor: _theme.colors.mode.containerBackgroundColor2,
      borderBottomColor: _theme.colors.mode.containerBackgroundColor4,
      borderBottomWidth: 1,
      display: "flex",
      flexDirection: "row",
      height: 32,
      justifyContent: "space-between",
      paddingHorizontal: 10,
      width: "100%",
    },
    backToParentText: {
      color: _theme.colors.mode.textColor3,
      fontWeight: "400",
      fontSize: 16,
    },
    backToParentIcon: {
      color: _theme.colors.mode.textColor3,
      fontSize: 22,
      height: 24,
      lineHeight: 26,
    },
    sideScreenContainer: {
      alignItems: "flex-start",
      display: "flex",
      flexDirection: "column",
      height: (fullScreenHeight-60-32),  // ⬆ Minus height of 'Header' & 'backToParentRow'.
      justifyContent: "stretch",
      overflow: "auto",
      position: "relative",
      width: "100%",
    },
  };
  return sharedStyles;
};
